import { environment } from '@environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IIban } from '@interfaces/iban.interface';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IbanService {
  baseUrl = environment.DOMAIN;
  constructor(private http: HttpClient) {

  }

  private invalidIbanSubject = new BehaviorSubject<boolean>(false);
  invalidIban$ = this.invalidIbanSubject.asObservable();

  setInvalidIban(isInvalid: boolean) {
    this.invalidIbanSubject.next(isInvalid);
  }

  checkIBAN(body: IIban): Observable<any> {
    var headers = new HttpHeaders();
    return this.http.post(
      `${this.baseUrl}/${environment.API.WEB.COMPROBAR_IBAN}`,
      body,
      { headers }
    );
  }
}
